import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'

function toCalendarGridResponse({
  dayLoads = EMPTY_OBJECT,
  items = EMPTY_LIST,
  meta = EMPTY_OBJECT,
}) {
  return { dayLoads, items, meta }
}

export function getCalendarGridResponse(response) {
  return toCalendarGridResponse(
    Array.isArray(response) ? { items: response } : response
  )
}
